const CacheKeys = {
    deliveryAddressKey: 'deliveryAddress',
    invoiceAddressKey: 'invoiceAddress',
    shipToDifferentAddress: 'shipToDifferentAddress',
    specialInformation: 'specialInformation'
};

export default CacheKeys;